import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificatenoFloatPointService {

  constructor(private http:HttpClient) { }

  GetRecord(id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/CertificatenoFloatPoint?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }



  Submit(model:Array<General_Interface>,id:number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var model_temp = []
    for (let item of model)
    {
      model_temp.push({
        float_id : item.id,
        point : Number(item.code),
      })
    }

    var body={
      Model:model_temp,
      id:id,
    }
    return this.http.post(environment.BaseUrl + "Daro/CertificatenoFloatPoint/PostFloat",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )

  }

}
